"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiCall = void 0;
const api_call_definition_1 = require("./helpers/api-call-definition");
const define_api_get_call_1 = require("./helpers/define-api-get-call");
const define_api_post_call_1 = require("./helpers/define-api-post-call");
class ApiCall {
    get(routeName, definition) {
        function define(api) {
            return define_api_get_call_1.defineApiGetCall(api, routeName, definition);
        }
        return new api_call_definition_1.ApiCallDefinition(define);
    }
    post(routeName, definition) {
        function define(api) {
            return define_api_post_call_1.defineApiPostCall(api, routeName, definition);
        }
        return new api_call_definition_1.ApiCallDefinition(define);
    }
}
exports.ApiCall = ApiCall;
